import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import map from 'lodash/map';
import Chart from 'chart.js';
import Loader from '../../../../../components/Loader';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';
import {getUberEatsUsersByDay} from '../../../../../actions/entities/uberEats';
import {isEmpty} from 'lodash';
import './index.css';

let chart;

class UberEatsPlayersPerDayWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start};
  }

  fetchStats() {
    const {end, start} = this.state;
    this.props.dispatch(getUberEatsUsersByDay({end, start}));
  }

  componentDidMount() {
    this.fetchStats();

    const ctx = document.getElementById('newMembersChart');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.stats.data !== this.props.stats.data) {
      const datasets = [
        {
          label: 'Players',
          backgroundColor: '#454545',
          xAxisID: 'date',
          yAxisID: 'members',
          data: [],
        },
      ];

      map(Object.entries(nextProps.stats.data?.days), mpg => {
        datasets[0].data.push({
          x: moment(mpg[0]).format('LL'),
          y: parseInt(mpg[1], 10),
        });
      });

      chart.data.datasets = datasets;
      chart.update();
    }
  }

  render() {
    const {end, start} = this.state;
    let {stats, isFetching} = this.props;

    const data = Object.entries(stats?.data?.days || {})
      .map(([key, value]) => ({key, value}))
      .sort((a, b) => {
        return new Date(a.key) - new Date(b.key);
      });

    return (
      <div id="registrations-widget" className="row">
        <div className="col-md-12">
          <div className="box">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-user" /> Players per day
              </h3>
            </div>
            <div className="box-body">
              <div className="text-center margin-bottom">
                <div className="inline data-range-picker">
                  <DateRangePickerWrapper
                    initialStartDate={moment(start)}
                    initialEndDate={moment(end)}
                    minimumNights={0}
                    onDatesChange={({startDate, endDate}) => {
                      this.setState({
                        start: moment(startDate).format('YYYY-MM-DD'),
                        end: moment(endDate).format('YYYY-MM-DD'),
                      });
                    }}
                  />
                  <button
                    className="btn btn-default"
                    onClick={() => this.fetchStats()}>
                    <i className="fa fa-refresh" />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="chart">
                    <canvas id="newMembersChart" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table-responsive table-fixed-height">
                    <table className="table table-bordered no-margin">
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th className="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => {
                          return (
                            <tr key={index} className="text-center">
                              <td className="text-left">
                                {moment(item.key).format('LL')}
                              </td>
                              <td>{item.value}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    stats: state.app.uberEats.stats,
  }),
  dispatch => ({dispatch}),
)(UberEatsPlayersPerDayWidget);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Stats/Widgets/PlayersPerDay/index.js